import React from "react";
import { useHistory } from "react-router-dom";
import ModalDisplay from "../Partials/ModalDisplay";
import Div from "../../components/common/Div";
import Text from "../../components/common/Text";
import ModalButton from "../../components/common/ModalButton";
import { tenzero } from "../../constants/Constants";
import { Typography } from "@mui/material";
import ExitToAppIcon from "@mui/icons-material/PowerSettingsNewRounded";

export default function LogOutBox(props) {
  const history = useHistory();

  function OkHandler() {
    localStorage.setItem("logoutInitiated", "true"); // Set logout intent in localStorage
    localStorage.setItem("isLoggedIn", "0");
    history.push("/login");
  }

  let displayValue = "none";
  if (props.display) displayValue = "block";

  return (
    <ModalDisplay display={displayValue}>
      <Div margin={tenzero} style={{ textAlign: "center" }}>
        <div style={iconContainerStyle}>
          <ExitToAppIcon style={successIconStyle} />{" "}
        </div>
        <Typography
          fontWeight={"bold"}
          color={"rgb(33, 42, 65)"}
          style={{ fontSize: "1.25rem", textAlign: "center" }}
        >
          Logout
        </Typography>
      </Div>
      <Div margin={tenzero}>
        <Text color={"rgb(33, 42, 65)"} fontSize={"0.9rem"}>
          Are you sure you want to log out?
        </Text>
      </Div>
      <Div
        margin={tenzero}
        style={{ display: "flex", justifyContent: "space-between" }}
      >
        <ModalButton onClick={props.handler}>Cancel</ModalButton>
        <ModalButton onClick={OkHandler}>Confirm</ModalButton>
      </Div>
    </ModalDisplay>
  );
}
const iconContainerStyle = {
  display: "flex",
  width: "fit-content",
  justifyContent: "center",
  marginBottom: "15px",
  backgroundColor: "rgb(33, 42, 65, 0.3)",
  borderRadius: "20%",
  padding: "10px",
  margin: "0 auto",
};

const successIconStyle = {
  color: "rgb(33, 42, 65)",
  fontSize: "2rem",
};
